import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import styled from "styled-components";
import { Blocks, BlockWrapper, DataBlocks } from "./components/DataBlocks";
import { MainTitle } from "./components/Title";
import { ProductImage } from "./ProductImage";
export { DefaultAfterContent, DefaultBeforeContent } from "./components/DataBlocks";
const stopPropagation = (e) => e.stopPropagation();
export const productSummaryTableSizeRelation = {
    "50": {
        size: "100",
        imageSize: "50",
        titleLineClamp: 1,
    },
    "100": {
        size: "100",
        imageSize: "150",
        titleLineClamp: 2,
    },
    "200": {
        size: "100",
        imageSize: "200",
        titleLineClamp: 3,
    },
    "400": {
        size: "100",
        imageSize: "400",
        titleLineClamp: 4,
    },
};
const sizeRelation = {
    "100": "100",
    "400": "400",
    dropdown: "100",
};
const _ProductSummary = memo(({ className, size = "100", titleLineClamp, blocks, marketplace, tooltipOptions, imageTooltipOptions, blocksInline, overflowTitleTooltip, overflowBlocksTooltip, imageTooltipContent, titleTooltipContent, onImageClick = stopPropagation, onTitleClick = stopPropagation, openTitleLinkInNewTab, renderBlocks, titleTestId, ...props }) => {
    const computedImageSize = useMemo(() => {
        return props.imageSize || sizeRelation[size];
    }, [props.imageSize, size]);
    return (_jsxs(Wrapper, { className: className, children: [_jsx(ProductImage, { size: computedImageSize, onImageClick: onImageClick, product: props.product, market: props.market, tooltipContent: imageTooltipContent, tooltipOptions: imageTooltipOptions }), _jsxs(Info, { "$size": size, "$imageSize": computedImageSize, children: [_jsx(MainTitle, { onTitleClick: onTitleClick, openTitleLinkInNewTab: openTitleLinkInNewTab, overflowTitleTooltip: overflowTitleTooltip, titleTooltipContent: titleTooltipContent, product: props.product, size: size, titleLineClamp: titleLineClamp, tooltipOptions: tooltipOptions, titleTestId: titleTestId }), renderBlocks || (_jsx(DataBlocks, { blocks: blocks, blocksInline: blocksInline, marketplace: marketplace, overflowBlocksTooltip: overflowBlocksTooltip, size: size }))] })] }));
});
const Info = styled.div `
  display: flex;
  flex-direction: column;
  margin-left: ${(p) => p.$size === "dropdown" || p.$imageSize === "50" ? p.theme.spacing.sp8 : p.theme.spacing.sp16};
  min-width: 0;
  width: 100%;
`;
const Wrapper = styled.div `
  display: flex;
  width: 100%;
  align-items: flex-start;
  min-width: 0;
`;
export const ProductSummary = Object.assign(_ProductSummary, {
    Wrapper,
    Blocks,
    Info,
    BlockWrapper,
});
